import React from "react";
import styled from "styled-components";
import close from "assets/images/icons/close.svg";
import {media} from "assets/css/media";
import {PureButton} from "components";

const ModalWrapper = styled.div`
	position: fixed;
	width: 100%;
	height: 100%;
	top: 0;
	right: 0;
	background: rgba(0, 0, 0, 0.5);
	box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.2);
	z-index: 15;
	display: flex;
	justify-content: center;
	align-items: center;
`;

interface IModalProps {
	width?: string;
}

const ModalInner = styled.div<IModalProps>`
	background: #fff;
	position: relative;
	box-sizing: border-box;
	max-height: 90%;
	max-width: ${({width}) => width || "600px"};
	width: 100%;
	overflow: auto;

	@media screen and (max-width: ${media.mobile}) {
		max-width: 95%;
	}
`;

const CloseButton = styled(PureButton)`
	position: absolute;
	top: 0;
	right: 0;
	cursor: pointer;
	width: 40px;
	height: 40px;
	z-index: 1;
	img {
		vertical-align: middle;
	}
`;

interface IProps {
	children?: React.ReactNode;
	onClose?: () => null | void;
	width?: string;
	closeIcon?: string;
}

export const Modal: React.FC<IProps> = ({children = null, onClose, closeIcon, ...rest}: IProps) => {
	const iconClose = closeIcon || close;

	return (
		<ModalWrapper>
			<ModalInner {...rest} className="modal-inner">
				{onClose ? (
					<CloseButton onClick={onClose}>
						<img src={iconClose} alt="Close" />
					</CloseButton>
				) : null}
				{children}
			</ModalInner>
		</ModalWrapper>
	);
};

export * from "./ErrorModal";
